/**
 * 讲师
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectTeacherById = (Id) => {
    return get('/api/app/Teacher?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddTeacher = (data) => {
    return post('/api/app/Teacher', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyTeacher = (data) => {
    return put('/api/app/Teacher', data, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataTeacherList = (data) => {
    return post('/api/app/Teacher/list', data, {});
  }

  /**
   * 链表分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataByPageQuery = (data) => {
    return post('/api/app/teacher/getDataByPageQuery', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteTeacher = (id) => {
    return del('/api/app/Teacher/' + id, {}, {});
  }

